import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    if (this.element.parentNode === document.body) return

    document.body.appendChild(this.element)
  }
}
